import $ from 'jquery';

export default {
  inserted(el) {
    $(el).on('keypress', event => {
      if (!(event.charCode >= 48 && event.charCode <= 57)) {
        event.preventDefault();
      }
    });
  },
};
